import axios from "axios";
import { store } from "../store/store";
import { crudChanged } from "../store/crudSync";

let registered = false;

export function registerAxiosCrudSync() {
  if (registered) return;
  registered = true;

  axios.interceptors.response.use(
    (response) => {
      const method = String(response?.config?.method || "get").toLowerCase();
      if (!["post", "put", "patch", "delete"].includes(method)) return response;

      const url = String(response?.config?.url || "");
      const isApiCall = url.includes("/api/") || url.startsWith("/api") || url.includes("localhost");
      if (isApiCall) {
        store.dispatch(crudChanged({ source: "axios-global", method }));
      }
      return response;
    },
    (error) => Promise.reject(error)
  );
}

